import React, { useContext, useEffect } from "react";
import { PropTypes } from "prop-types";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import { ParcelDataContext } from "../../Contexts/ParcelDataContext";
import ParcelDataTable from "./ParcelDataTable";
import CreateParcel from "./CreateParcel";
import { statuses, pageSize } from "../../Mappings";
import { AppStateContext } from "../../Contexts/AppStateContext";
import ButtonLoadMore from "../ButtonLoadMore";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const useStyles = makeStyles((theme) => ({
  divider: {
    padding: 0,
  },
  add: {
    textAlign: "center",
  },
  table: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

const ParcelDisplayDay = (props) => {
  const classes = useStyles();
  const { parcelData } = useContext(ParcelDataContext);
  const { truckId, week, day, parcelSummary, setParcelSummaryPerEventDate } = props;
  const { tableOpen, setTableOpen, scrollToPosition } =
    useContext(AppStateContext);

  let data = {};
  let currentDayRemaining = 0;

  const isShowLoadMoreButton = parcelSummary?.isShowLoadMoreButton;
  
  if(parcelSummary) {
    const { currentListTotal, totalRecords } = parcelSummary;

    if(currentListTotal && totalRecords)
      currentDayRemaining = parseInt(totalRecords) - parseInt(currentListTotal)
  }

  const loadMore = () => {
    setParcelSummaryPerEventDate((state) => {
      
      const parcelSummaryPerEventDate = state.map(item => ({
        ...item,
        isSelectedToLoadMore: false
      }));

      const currentIndex = parcelSummaryPerEventDate.findIndex( f => f.weekDay == day);
      const { currentPage, currentListTotal, totalRecords} = parcelSummaryPerEventDate[currentIndex];
      parcelSummaryPerEventDate[currentIndex].currentPage =  currentPage + 1;
      parcelSummaryPerEventDate[currentIndex].isShowLoadMoreButton = totalRecords > (currentListTotal + pageSize);
      parcelSummaryPerEventDate[currentIndex].currentListTotal =  currentListTotal + pageSize;
      parcelSummaryPerEventDate[currentIndex].isSelectedToLoadMore = true;
      
      return parcelSummaryPerEventDate;
    })
  }  

  if (truckId in parcelData) {
    if (week in parcelData[truckId]) {
      if (day in parcelData[truckId][week]) {
        data = parcelData[truckId][week][day];
      }
    }
  }

  const totals = {
    dpc: Object.keys(data).reduce(
      (acc, cur) =>
        data[cur].approvalState === statuses.deletedApproved ||
        data[cur].approvalState === statuses.hourlyLinked
          ? acc
          : acc + data[cur].dpc,
      0
    ),
  };

  // // return to uses last position before a refresh was done
  // useEffect(() => {
  //   scrollToPosition();
  // }, [parcelData, scrollToPosition]);

  return (
    <Accordion
      expanded={tableOpen[day]}
      onChange={(event, isExpanded) =>
        setTableOpen({ ...tableOpen, [day]: isExpanded })
      }
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-start"
        >
          <Grid item xs={2}>
            <Typography>{days[day]}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>Records: {parcelSummary?.totalRecords ?? 0}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>
              DPC: ${(parcelSummary?.totalDpc ?? 0).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails className={classes.table}>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
          spacing={2}
        >
          <Grid item className={classes.add}>
            <CreateParcel truckId={truckId} week={week} day={day} />
          </Grid>
          <Grid item>
            <ParcelDataTable
              data={data}
              truckId={truckId}
              week={week}
              day={day}
            />
          </Grid>
          {isShowLoadMoreButton ? 
            <ButtonLoadMore remaining={currentDayRemaining} onClickLoadMore={loadMore} />
            : null
          } 
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default ParcelDisplayDay;

ParcelDisplayDay.propTypes = {
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
};
